// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminContact } from './admin-contact';
import { Asset } from './asset';
import { Bankrupt } from './bankrupt';
import { ContactAddress } from './contact-address';
import { ContactMailingList } from './contact-mailing-list';
import { ContactNumber } from './contact-number';
import { Counterparty } from './counterparty';
import { Creditor } from './creditor';
import { CreditorContact } from './creditor-contact';
import { DocumentRecipient } from './document-recipient';
import { MergeTemplate } from './merge-template';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Contact extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  contactId!: number;
  contactUserUserId?: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  firstName!: string;
  gender?: string;
  lastName!: string;
  mailToParent!: boolean;
  positionTitle?: string;
  reference1?: string;
  reference2?: string;
  salutation!: string;
  title?: string;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webFlags?: number;
  adminContacts!: AdminContact[];
  assets!: Asset[];
  bankruptAccountantContacts!: Bankrupt[];
  bankruptContactPersonContacts!: Bankrupt[];
  bankruptSolicitorContacts!: Bankrupt[];
  contactAddresses!: ContactAddress[];
  contactMailingLists!: ContactMailingList[];
  contactNumbers!: ContactNumber[];
  counterparty!: Counterparty;
  creditorContacts!: CreditorContact[];
  creditors!: Creditor[];
  documentRecipients!: DocumentRecipient[];
  mergeTemplates!: MergeTemplate[];
}

